"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.object.to-string.js");
var _vuescroll = _interopRequireDefault(require("vuescroll"));
var _IceTreeTemplate = _interopRequireDefault(require("@/components/IcePopSelector/IceTreeTemplate"));
var _request = _interopRequireDefault(require("@/utils/request"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "IceTree",
  mixins: [_IceTreeTemplate.default],
  data: function data() {
    return {
      ops: {
        bar: {
          background: "#fff",
          opacity: 0
        },
        scrollPanel: {
          initialScrollY: true,
          initialScrollX: true,
          scrollingX: true,
          scrollingY: true
        }
      },
      filterText: "",
      defaultProps: {
        children: this.childrenProp,
        label: this.labelProp,
        isLeaf: "leaf"
      },
      defaultExpand: [],
      data: [],
      selected: ""
    };
  },
  methods: {
    load: function load(node, resolve) {
      if (node.level == 0) {
        //获取根节点
        this.loadData(this.rootValue, resolve, true);
      } else {
        this.loadData(node.data[this.valueProp], resolve, false);
      }
    },
    loadData: function loadData(pid, resolve, isroot) {
      var _this = this;
      var params = {};
      params[this.treeParentProp] = pid;
      this.$axios.get(this.loadUrl, {
        params: params
      }).then(function (result) {
        resolve(result.data);
        if (isroot && result.data.length > 0) {
          _this.$refs.tree.setCurrentKey(result.data[0][_this.valueProp]);
          _this.selected = result.data[0][_this.valueProp];
          _this.$emit("node-click", result.data[0][_this.valueProp], _this.$refs.tree.getNode(_this.data[0][_this.valueProp]), _this.$refs.tree);
          _this.defaultExpand = [result.data[0][_this.valueProp]];
        }
      }).catch(function (error) {
        console.error(error.message);
      });
    },
    handleNodeClick: function handleNodeClick(data, node, nodeComponent) {
      this.selected = data[this.valueProp];
      this.$emit("node-click", data[this.valueProp], node, nodeComponent);
    },
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data[this.labelProp] ? data[this.labelProp].indexOf(value) !== -1 : false;
    },
    addNode: function addNode(data) {
      this.$refs.tree.append(data, this.$refs.tree.getNode(this.$refs.tree.getCurrentKey()));
    },
    updateNode: function updateNode(data) {
      //console.log("updateNode")
      var node = this.$refs.tree.getNode(this.$refs.tree.getCurrentKey());
      node.data = data;
    },
    deleteNode: function deleteNode() {
      this.selected = "";
      this.$refs.tree.getNode(this.$refs.tree.getCurrentKey()).remove();
    },
    getCheckedNodes: function getCheckedNodes(leafOnly, includeHalfChecked) {
      return this.$refs.tree.getCheckedNodes(leafOnly, includeHalfChecked);
    },
    nodeCheck: function nodeCheck(changeNode, nodeStatus) {
      this.$emit("node-check", changeNode, nodeStatus);
    },
    setChecked: function setChecked(key_data, checked, deep) {
      this.$refs.tree.setChecked(key_data, checked, deep);
    },
    setCheckedNodes: function setCheckedNodes(nodes) {
      this.$refs.tree.setCheckedNodes(nodes);
    },
    setCheckedKeys: function setCheckedKeys(keys, leafOnly) {
      this.$refs.tree.setCheckedKeys(keys, leafOnly);
    },
    refresh: function refresh() {
      var _this2 = this;
      if (this.treeData) {
        this.data = this.treeData;
        this.$nextTick(function () {
          _this2.$refs.tree.setCurrentKey(_this2.data[0][_this2.valueProp]);
          _this2.selected = _this2.data[0][_this2.valueProp];
          _this2.$emit("node-click", _this2.data[0][_this2.valueProp], _this2.$refs.tree.getNode(_this2.data[0][_this2.valueProp]), _this2.$refs.tree);
          _this2.defaultExpand = [_this2.data[0][_this2.valueProp]];
        });
      }
      if (this.lazy === false) {
        (0, _request.default)({
          url: this.loadUrl,
          method: this.treeMethod
        }).then(function (result) {
          _this2.data = result.data;
          _this2.$nextTick(function () {
            _this2.$refs.tree.setCurrentKey(_this2.data[0][_this2.valueProp]);
            _this2.selected = _this2.data[0][_this2.valueProp];
            _this2.$emit("node-click", _this2.data[0][_this2.valueProp], _this2.$refs.tree.getNode(_this2.data[0][_this2.valueProp]), _this2.$refs.tree);
            _this2.defaultExpand = [_this2.data[0][_this2.valueProp]];
          });
        }).catch(function (error) {
          console.error(error.message);
        });
      }
    }
  },
  computed: {
    isLazy: function isLazy() {
      return this.treeData ? false : this.lazy;
    }
  },
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  mounted: function mounted() {
    this.refresh();
  },
  components: {
    VueScroll: _vuescroll.default
  }
};